import { render, staticRenderFns } from "./FloodRisks.vue?vue&type=template&id=2f13acbf&scoped=true"
import script from "./FloodRisks.vue?vue&type=script&lang=ts"
export * from "./FloodRisks.vue?vue&type=script&lang=ts"
import style0 from "./FloodRisks.vue?vue&type=style&index=0&id=2f13acbf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f13acbf",
  null
  
)

export default component.exports